<div class="fundo" role="dialog" aria-modal="true" [attr.aria-label]="liberar ? 'Liberar reserva' : 'Reservar horário'">
  <div class="modal estreito">
    <div class="modal-cab">
      <div class="cab-ico" aria-hidden="true"><svg class="i" viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg></div>
      <div class="cab-txt">
        <b>{{ liberar ? 'Liberar reserva' : 'Reservar horário' }}</b>
        <span>{{ linha.dsAgenda }}{{ linha.dsAgenda ? ' · ' : '' }}{{ dataBr }} · {{ linha.hrInicio }}</span>
      </div>
      <button type="button" class="btn-ico fechar-modal" title="Fechar" (click)="cancelar()" [disabled]="salvando">
        <svg class="i" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>
      </button>
    </div>

    <div class="modal-corpo">
      <p class="texto" *ngIf="liberar">
        O horário das <b>{{ linha.hrInicio }}</b> está reservado. Ao liberar, ele volta a aparecer como livre para todos.
      </p>
      <div class="alerta info" *ngIf="!liberar">
        <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6z" /></svg>
        <div>O horário fica <b>reservado</b>: some da grade e da busca de vagas para quem não é supervisão. Só a supervisão agenda nele ou libera.</div>
      </div>
      <div class="alerta bad" *ngIf="erro" role="alert">
        <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
        <div>{{ erro }}</div>
      </div>
    </div>

    <div class="modal-rod">
      <button type="button" class="btn btn-contorno" (click)="cancelar()" [disabled]="salvando">Voltar</button>
      <button type="button" class="btn btn-primario" (click)="confirmar()" [disabled]="salvando">
        <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6z" /></svg>
        {{ salvando ? 'Gravando...' : liberar ? 'Liberar horário' : 'Reservar' }}
      </button>
    </div>
  </div>
</div>
